import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import MenuScreen from "./MenuScreen";
import EditProfile from "./EditProfile";
// import { fetchContent } from "../services/api";
import selectedIcon from "../assets/selectedIcon.png";
import { Translate } from "./LanguageChanger";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import backIcon from "../assets/back-button.png";
import Wrapper from "./shared/Wrapper";
import { getUserProfile, updateUserProfile } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const UpdateProfile = ({ navigate, isLogedIn }) => {
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const handleInputFocus = () => {
    if(!inputRef.current.readOnly){
    setKeyboardOpen(true);
    }
  };
  const handleInputBlur = () => {
    setKeyboardOpen(false);
  };

  const [name, setName] = useState(
    JSON.parse(localStorage.getItem("EditProfile")).name
  );
  const [isKidsProfile, setIsKidsProfile] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [confirmedSelection, setConfirmedSelection] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [state, setState] = useState({
    isAddButton: false,
    shouldCloseMenu: true,
    isBackButtonSelected: false,
  });
  const { isAddButton, shouldCloseMenu, isBackButtonSelected } = state;

  const [screen, setScreen] = useState("UpdateProfile");
  const [data, setData] = useState({});

  const navigateToScreen = (screenName) => {
    setScreen(screenName);
    // setData(data);
    window.addEventListener("keydown", UpdateProfileKeyHandler);
  };

  const masterData = JSON.parse(localStorage.getItem("masterData")) || [];
  // const myprofile = masterData.data?.avatar || [];

  const myprofile = (masterData.data?.avatar || []).slice(0, 10);

  let user_details = JSON.parse(
    localStorage.getItem("user_details")
  ).user_profiles;
  // const user_profile = JSON.parse(user_details);

  // const updatedMyprofile = JSON.parse(localStorage.getItem("updateMyProfile")).data;

  // const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  const updatedMyprofile = localStorage.getItem("updateMyProfile")
    ? JSON.parse(localStorage.getItem("updateMyProfile")).data
    : null;

  // const user_profile = updatedMyprofile ? updatedMyprofile.data : user_details.user_profiles;

  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  // const ProfileId = user_profile

  const [profiles, setProfiles] = useState(
    user_profile.map((profile) => ({
      name: profile.username,
      image: profile.profile,
      isKids: profile.is_kid,
      profileId: profile.profile_id,
    }))
  );

  const avatarRefs = useRef([]);
  const inputRef = useRef(null);
  const toggleRef = useRef(null);
  const buttonRef = useRef(null);
  const backButtonRef = useRef(null);

  const loadData = async () => {
    const getCountry = localStorage.getItem("country");
 if (!name || (typeof name === 'string' && name.trim() === "")) {
      setErrorMessage(<Translate langKey={'plz_enter_name'}/> || "Please enter a name");
      // clear the message after 2 seconds to reuse existing UX
      setTimeout(() => setErrorMessage(""), 2000);
      return;
    }
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    const profilId = JSON.parse(localStorage.getItem("selectedUpdateProfile"));

    const profile_img = JSON.parse(
      localStorage.getItem("selectedUpdateProfile")
    );

    // const profileName = JSON.parse(localStorage.getItem("EditProfile")).name;
    const profileId = JSON.parse(localStorage.getItem("EditProfile")).profileId;
    const profileImg =
      JSON.parse(localStorage.getItem("selectedUpdateProfile"))?.url ||
      JSON.parse(localStorage.getItem("EditProfile"))?.image;
    console.log("profileImg", profileImg);
    const isKid = JSON.parse(localStorage.getItem("EditProfile"))?.isKids;

    const raw = {
      // profile_id: profiles[`${selectedIndex}`].profileId,
      profile_id: profileId,
      activity: 2,
      username: name,
      profile: profileImg,
      is_kid: isKid,
    };

    let body = JSON.stringify(raw);

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     "/V1/updateUserProfile",
      //     "POST",
      //     myHeaders,
      //     body
      //   )
      // ]);
      const response = await updateUserProfile(raw);
      let updateProfile;

      const userDetails = JSON.parse(localStorage.getItem("user_details"));
 
      if (userDetails && userDetails?.user_profiles && userDetails?.user_profiles?.[0]) {
        // Update the profile key
        userDetails.user_profiles[0].profile = raw.profile;
 
        // Save the updated user details back to localStorage
        localStorage.setItem("user_details", JSON.stringify(userDetails));
      }

      if (response.statusCode === 200) {
        updateProfile = <Translate langKey={"update_profile"} />;

        sendTestMatomoEvent({
          eventCategory: "Profile",
          eventAction: "Edit",
          eventName: `${raw?.profile_id}/${raw?.username}/${raw.is_kid === 0 ? "Adult" : "Child"
            }`,
          url: "profile",
        });
        setErrorMessage(updateProfile);
      } else {
        updateProfile = <Translate langKey={"failed_update_profile"} />;
        setErrorMessage(updateProfile);
      }


      setTimeout(() => {
        setErrorMessage("");
        updateloadData();
      }, 2000);
    } catch (error) {
      // console.error("Error fetching data:", error);
      setErrorMessage(error.responseJSON.message[0]);
      // updateloadData();

      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
    }
  };

  const handleNameChange = (e) => {
    const inputValue = e.target.value;

    // Regex: Start with alphabet, followed by alphabets, numbers, spaces, or special characters
    const validNameRegex =
      /^[a-zA-Z][a-zA-Z0-9\s!@#$%^&*()_+={}[\]:;"'<>,.?/-]*$/;

    if (inputValue === "" || validNameRegex.test(inputValue)) {
      setName(inputValue);
      setErrorMessage(""); // Clear error
    } else {
      setErrorMessage("Username should start with an alphabet.");
    }
  };

  const updateloadData = async () => {
     window.initialCall = false
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   )
      // ]);

      const response = await getUserProfile(userId);

      localStorage.setItem("updateMyProfile", JSON.stringify(response));
      if (response.statusCode === 200) {
        navigate("ProfileScreen");
        // MenuScreen.ReseTfocus(-1);
        // setState((prevState) => ({
        //   ...prevState,
        //   updateData: response.data,
        //   shouldShowModal: false
        // }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const UpdateProfileKeyHandler = (event) => {
    switch (event.keyCode) {
     case 13: // Enter key
        if (selectedIndex >= 0 && selectedIndex < myprofile.length && !isBackButtonSelected) {
          // Save selected avatar profile
          localStorage.setItem(
            "selectedAddProfile",
            JSON.stringify(myprofile[selectedIndex])
          );
          setConfirmedSelection(selectedIndex);
          if (inputRef.current) {
            inputRef.current.blur(); // Hide keyboard
          }
          // console.log("selectedIndex", selectedIndex);
        } else if (selectedIndex === myprofile.length + 2) {
          // Perform action on Update button
          // console.log("loadData.........");
          loadData();
        } else if (isBackButtonSelected) {
          handleBackButton();
        } else if (selectedIndex === myprofile.length) {
            setKeyboardOpen(true); // Unlock keyboard
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
        break;

      case 39: // Right arrow
        if (isBackButtonSelected) {
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
          }));
          setSelectedIndex(0);
          return;
        }
        if (selectedIndex < myprofile.length - 1) {
          setSelectedIndex((prevIndex) => prevIndex + 1);
        }
        break;

      // case 37: // Left arrow
      //   if (selectedIndex > 0) {
      //     setSelectedIndex((prevIndex) => prevIndex - 1);
      //   }
      //   break;

       case 37: // Left arrow
        if (selectedIndex > 0) {
          setSelectedIndex((prevIndex) => prevIndex - 1);
        } else {
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: true,
          }));
          setSelectedIndex(-1);
          if (backButtonRef.current) {
            backButtonRef.current.focus();
          }
        }
        break;

      case 38: // Up arrow
        if (selectedIndex > 4 && selectedIndex < myprofile.length) {
          setSelectedIndex((prevIndex) => prevIndex - 5); // Move upwards within avatars
        } else if (selectedIndex === myprofile.length) {
          // Move from input field to avatars
          setSelectedIndex(myprofile.length - 1);
        } else if (selectedIndex === myprofile.length + 2) {
          // Move from Add button to input field, skip the toggle button
          setSelectedIndex(myprofile.length);
        }
        break;

      case 40: // Down arrow
        if (isBackButtonSelected) {
          setState((prevState) => ({
            ...prevState,
            isBackButtonSelected: false,
          }));
          setSelectedIndex(0);
          return;
        }
        if (selectedIndex < myprofile.length - 5) {
          setSelectedIndex((prevIndex) => prevIndex + 5); // Navigate avatars down
        } else if (
          selectedIndex >= myprofile.length - 5 &&
          selectedIndex < myprofile.length
        ) {
          // Move from avatar to input field
          setSelectedIndex(myprofile.length);
        } else if (selectedIndex === myprofile.length) {
          // Move from input field to Add button, skip the toggle button
          setSelectedIndex(myprofile.length + 2);
        }
        break;

      case 461: // Back key
      case 8: // Backspace
      case 10009: // Return key
        if (
          !state.isUserInputBoxSelected &&
          selectedIndex !== myprofile.length
        ) {
          handleBackButton();
        }
        break;

      default:
        break;
    }
  };

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleRightButton = () => {
    // First, update the state
    setSelectedIndex(0);
    // document.getElementById("profile_0").focus();
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
    }));

    // Then perform DOM operations and other actions outside the state update
    MenuScreen.SetFocus(true);

    // Uncomment if you want to navigate to the CategoryScreen
    // navigate("CategoryScreen");
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Exit", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const upDateProfile = () => {
    loadData();
  };

  const handleBackButton = () => {
    // console.log("handleBackButton   ---- = ", screen);
    window.removeEventListener("keydown", UpdateProfileKeyHandler);
    navigate("ProfileScreen");
    // navigateToScreen("EditProfile");
    // window.removeEventListener("keydown", UpdateProfileKeyHandler);
    // setState((prevState) => ({
    //   ...prevState,
    //   shouldCloseMenu: false,
    // }));
    // MenuScreen.SetFocus(false);
  };

  const handleLogout = (p) => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  useEffect(() => {
    window.addEventListener("keydown", UpdateProfileKeyHandler);
    return () => {
      window.removeEventListener("keydown", UpdateProfileKeyHandler);
    };
  }, [selectedIndex, keyboardOpen]);   // Added keyboardOpen dependency

  useEffect(() => {
    // console.log("useEffect selectedIndex ---- = ", selectedIndex, myprofile.length);

    // Focus on avatars
    if (selectedIndex < myprofile.length) {
      setState((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: false,
        isToggleButtonSelected: false,
        isAddButton: false,
        // isBackButtonSelected: false,
      }));
      if (avatarRefs.current[selectedIndex]) {
        avatarRefs.current[selectedIndex].focus();
      }
    }
    // Navigate to input field, skipping toggle button
    else if (selectedIndex === myprofile.length) {
      // console.log("input box");
      setState((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: true,
        isToggleButtonSelected: false,
        isAddButton: false,
        isBackButtonSelected: false,
      }));

      // Focus on input box and set cursor to end 30/9/2024
      if (inputRef.current) {
        inputRef.current.focus();

        // Always check and push cursor to end if there's text
        requestAnimationFrame(() => {
          if (inputRef?.current.value.length > 0) {
            const length = inputRef?.current.value.length;
            inputRef?.current.setSelectionRange(length, length);
          }
        });
      }
      inputRef.current.focus();
    } else if (selectedIndex === myprofile.length + 2) {
      // console.log("add button..");
      setState((prevState) => ({
        ...prevState,
        isUserInputBoxSelected: false,
        isToggleButtonSelected: false,
        isAddButton: true,
        isBackButtonSelected: false,
      }));
      inputRef.current.blur();
      if (buttonRef?.current) {
        buttonRef.current.focus();
      }
    }
    // Prevent invalid index overflow
    else {
      setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    }
  }, [selectedIndex, myprofile.length]);

  const styles = {
        profileCard: {
      backgroundColor: "#0E1653",
      borderRadius: "16px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "2px solid white",
      width: "141px",
      height: "141px",
      padding: "0px",
      margin: "0px",
      backgroundSize: "cover",
    },
    container: {
      backgroundImage: `url(${solidbackgroundimg})`,
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      backgroundColor: "#000",
      color: "#fff",
      height: "100vh",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      // justifyContent: "center",
    },
    title: {
      fontFamily: "Anek Latin",
      marginBottom: "120px",
      fontWeight: 500,
      fontSize: "32px",
      color: "rgba(255, 255, 255, 1)",
    
    },
    avatarSelection: {
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      gap: "20px",
      marginBottom: "20px",
    },
    avatar: {
      width: "141px",
      height: "141px",
      borderRadius: "10px",
      cursor: "pointer",
      outline: "none",
    },
    avatarFocused: {
      border: "3px solid rgba(255, 255, 255, 1)",
    },
    nameInput: {
      outline:"none",
      width: "592px",
      fontSize:"1.3rem",
      padding: "16px 8px 16px 8px",
      marginBottom: "25px",
      borderRadius: "10px",
      border: "1px solid rgb(255, 255, 255)",
      backgroundColor: "#0E1653",
      // backgroundColor: "rgb(51, 51, 51)",
      color: "rgb(255, 255, 255)",
      height: "6vh",
      outline: selectedIndex === myprofile.length ? "2px solid #FFF" : "none",
    },
    kidsProfile: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
    },
    kidsProfileLabel: {
      marginRight: "10px",
      fontSize: "16px",
      color: "#ffffff",
      fontWeight: "400",
    },
    updateButton: {
      padding: "10px 20px",
      border: "none",
      borderRadius: "5px",
      backgroundColor: "#ff6f00",
      color: "#fff",
      cursor: "pointer",
    },
    updateButtonHover: {
      backgroundColor: "#e65c00",
    },
    kidsvideos: {
      right: "9vh",
      position: "relative",
      top: "3vh",
      fontSize: "14px",
      fontWeight: "400",
      color: "#7F7F7F",
    },
    selectedIcon: {
      position: "absolute",
      bottom: "0px",
      right: "-10px",
      width: "40px",
      height: "40px",
    },
  };

  const togglebutton = {};

  const inputbox = {
    position: "relative",
    top: "2vh",
  };

  if (screen === "EditProfile") {
    // console.log("move to myprofile page to deleteprofile page....");
    window.removeEventListener("keydown", UpdateProfileKeyHandler);
    return <EditProfile navigate={navigateToScreen} />;
  }

  const storedEditProfile = JSON.parse(localStorage.getItem("EditProfile"));
  const isEditProfileSelected = (profile) =>
    storedEditProfile && profile.url === storedEditProfile.image;

  // Ensure the EditProfile avatar is shown first in the list
  const rearrangedProfiles = [...myprofile].sort((a, b) => {
    if (isEditProfileSelected(a)) return -1; // Move the matching profile to the first index
    if (isEditProfileSelected(b)) return 1;
    return 0;
  });

  return (
    console.log(
      "confirmedSelection....",
      user_profile.find(
        (item) =>
          item.profile === JSON.parse(localStorage.getItem("EditProfile")).image
      )
    ),
    (
      <div style={styles.container}>
        <style>
          {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
        `}
        </style>
        <div style={{ position: "absolute" }}>
          <Wrapper
            as="button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "6rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              position: "relative",
              top: "4rem",
              zIndex: "1",
              // left: "6rem",
              outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
            }}
            onMouseEnter={() => {
              setState((prevState) => ({
                ...prevState,
                isBackButtonSelected: true,
              }));
              setSelectedIndex(-1);
            }}
            // onMouseLeave={()=> {
            //   setState((prevState) => ({
            //     ...prevState,
            //     isBackButtonSelected: false,
            //   }));
            // }}
            onClick={(e) => {
              handleBackButton();
              // handleBack();
              // handleClick(null, -2);
            }}
          >
            <img src={backIcon} width={50} height={50} />
          </Wrapper>
        </div>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            textAlign: "center",
            display:"flex",
          flexDirection:"column",
          height:"100vh",
          // top:"-4.9%",
          gap:"10px",
         justifyContent: "center",
          alignItems:"center"
          }}
        >
          <h1 style={styles.title}>
            <Translate langKey={"Edit-Profile"} />
          </h1>
          <div style={styles.avatarSelection}>
            {rearrangedProfiles.map((profile, index) => {
              const isProfileSelected = isEditProfileSelected(profile);

              return (
                <Wrapper
                  key={index}
                  ref={backButtonRef}
                  style={{
                    position: "relative", // This helps position the selected icon correctly
                    borderRadius:"16px",
                  }}
                  onMouseEnter={() => {
                    setState((prevState) => ({
                      ...prevState,
                      isBackButtonSelected: false,
                    }));
                    setSelectedIndex(index);
                  }}
                >
                  <img
                    src={profile.url}
                    alt="Avatar"
                    style={{
                      ...styles.avatar,
                      ...(selectedIndex === index && styles.avatarFocused),
                      ...styles.profileCard,
                    }}
                    tabIndex={0}
                    ref={(el) => (avatarRefs.current[index] = el)}
                    onClick={() => {
                      setSelectedIndex(index);
                      localStorage.setItem(
                        "selectedUpdateProfile",
                        JSON.stringify(profile)
                      );
                      setConfirmedSelection(index); // Update confirmed selection
                      // localStorage.removeItem("EditProfile"); // Remove previous EditProfile
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setSelectedIndex(index);
                        localStorage.setItem(
                          "selectedUpdateProfile",
                          JSON.stringify(profile)
                        );
                        setConfirmedSelection(index); // Update confirmed selection
                        // localStorage.removeItem("EditProfile"); // Remove previous EditProfile
                      }
                    }}
                  />
                  {(confirmedSelection === index ||
                    (isProfileSelected && confirmedSelection === null)) && (
                      <img
                        src={selectedIcon} // Replace with the actual path to your checkmark icon
                        alt="Selected"
                        style={styles.selectedIcon}
                      />
                    )}
                </Wrapper>
              );
            })}
          </div>

          <div style={inputbox}>
            <style>
              {`
          input::placeholder {
            color: rgba(237, 237, 237, 1);
            font-size: 20px;
            font-family: Anek Latin;
            font-weight:400;
          }
        `}
            </style>
            <input
              type="text"
              style={styles.nameInput}
              placeholder="Enter your name"
              maxLength={30}
              value={name}
              ref={inputRef}
              onChange={handleNameChange}
              readOnly={!keyboardOpen}
              onMouseEnter={() => {
                setState((prevState) => ({
                      ...prevState,
                      isBackButtonSelected: false,
                    }));
                setSelectedIndex(myprofile.length);
              }}
              onClick={() => {
                setKeyboardOpen(true); // Unlock keyboard on click
                if (inputRef.current) inputRef.current.focus();
              }}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              onKeyDown={(e) => {
                if ((e.keyCode === 37 || e.keyCode === 39) && keyboardOpen) {
                  // Let the default cursor movement happen (do not preventDefault)
                  // Do NOT trigger navigation
                  e.stopPropagation();
                  return;
                }
                if (e.keyCode === 13) {
                // Enter dabane par keyboard close aur next move
                if (!keyboardOpen) {
                   setKeyboardOpen(true);
                } else {
                   e.stopPropagation();
                   setSelectedIndex(myprofile.length + 2);
                   e.target.blur();
                   setKeyboardOpen(false);
                }
                return;
              }

              if (!keyboardOpen) {
                e.preventDefault(); // Lock input if keyboardOpen is false
                return;
              }
              }}
   />
          </div>
          <div style={{}}>
            <CustomButton
              navigateTo="/login"
              fontSize="24px"
              defaultSelected={isAddButton}
              height="7vh"
              top="5vh"
              left="0"
              position="relative"
              onClick={upDateProfile}
              ref={buttonRef}
              onKeyDown={UpdateProfileKeyHandler}
              onMouseEnter={() => {
                setState((prevState) => ({
                      ...prevState,
                      isBackButtonSelected: false,
                    }));
                setSelectedIndex(myprofile.length + 2);
              }}
              style={{
                width: "592px",
                ...(selectedIndex === myprofile.length + 2 ),
              }}
            >
              <Translate langKey={"edit_update"} />
            </CustomButton>
          </div>
          <div
            style={{
              height: "40px", // Reserve space for error message (adjust as needed)
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "2rem",
            }}
          >
            {errorMessage && (
              <p
                style={{
                  color: "white",

                  fontSize: "30px",
                  padding: 0,
                  position: "relative",
                  margin: "0 auto",
                  marginTop: "2rem",
                }}
              >
                {errorMessage}
              </p>
            )}
          </div>


        </div>
        <div style={{ position: "absolute" }}>
          <MenuScreen
            navigate={navigateToScreen}
            handleMenuselection={handleMenuselection}
            shouldCloseMenu={shouldCloseMenu}
            handleRightButton={handleRightButton}
            isLogedIn={isLogedIn}
            appNavigate={navigate}
            handleLogout={handleLogout}
            handleExit={handleExit}
          />
        </div>
        {/* {errorMessage && <p className="error-message">{errorMessage}</p>} */}
      </div>
    )
  );
};

export default UpdateProfile;

// Add this CSS to your stylesheet
const stylesCSS = `
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  left: 30vh;
  top: 2vh;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

  .error-message {
    color: red;
    font-size: 30px;
    margin-top: 50px;
    margin:0;
    padding:0;
  }

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: gray;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #333;
}

input:checked + .slider:before {
  transform: translateX(26px);
  background-color: #666;
}

.switch.focused {
  outline: 3px solid #ff6f00;
}
`;

// // Add the styles to your document
// const styleSheet = document.createElement("style");
// styleSheet.type = "text/css";
// styleSheet.innerText = stylesCSS;
// document.head.append(styleSheet);
